import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CustomTranslateLoader } from "../../../_services/custom.loader";
import { ESRIntgrationCompenent } from "./esr/esr.component";
import { CommonModule } from "@angular/common";
import { ESRApplicationStatusCompenent } from "./esr-application-status/esr-application-status.component";
import { SvgIconModule } from "../../../_customComponent/Icons/_svg/app-jt-svg-icon.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { UpdateESREmploymentModule } from "../../Esr/UpdateEsrEmployment/updateEsrEmployment.module";
import { ShareModule } from "../../../share.module";




@NgModule({
  declarations: [
    ESRIntgrationCompenent,
    ESRApplicationStatusCompenent
  ],
  imports: [
    CommonModule,
    SvgIconModule,
    NgbModule,
    TooltipModule.forRoot(),
    UpdateESREmploymentModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  exports: [ESRIntgrationCompenent, ESRApplicationStatusCompenent],
})
export class DataMigrationIntegrationModule { }
export function HttpLoaderFactory(http: HttpClient) {
  
  return new TranslateHttpLoader(http);
}
